import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function CustomerSales({
  title = "",
  infos = [],
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  // Calcular totales globales
  let total_grand_count = 0;
  let total_grand_premium = 0;
  let count_grand_guest = 0;
  let count_grand_logged = 0;
  let premium_grand_guest = 0;
  let premium_grand_logged = 0;

  Object.entries(infos).forEach(([index, info]) => {
    Object.entries(info.details).forEach(([index, row]) => {
      total_grand_count = row.cancel
        ? total_grand_count - 1
        : total_grand_count + 1;
      count_grand_guest =
        row.view === "guest" ? count_grand_guest + 1 : count_grand_guest;
      count_grand_logged =
        row.view === "customer" || row.view === "client" || row.view === "agent"
          ? count_grand_logged + 1
          : count_grand_logged;
      total_grand_premium = row.cancel
        ? total_grand_premium - parseFloat(row.revised_net_premium)
        : total_grand_premium + parseFloat(row.revised_net_premium);
      premium_grand_logged =
        row.view === "customer" || row.view === "client" || row.view === "agent"
          ? !row.cancel
            ? premium_grand_logged + parseFloat(row.revised_net_premium)
            : premium_grand_logged - parseFloat(row.revised_net_premium)
          : premium_grand_logged;
      premium_grand_guest =
        row.view === "guest"
          ? !row.cancel
            ? premium_grand_guest + parseFloat(row.revised_net_premium)
            : premium_grand_guest - parseFloat(row.revised_net_premium)
          : premium_grand_guest;
    });
  });

  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(18, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(18, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {Object.entries(infos).map(([_, info], idxInfo) => {
                      let total_count = 0;
                      let total_premium = 0;
                      let count_guest = 0;
                      let count_logged = 0;
                      let premium_guest = 0;
                      let premium_logged = 0;

                      info.details.forEach((row) => {
                        total_count = row.cancel
                          ? total_count - 1
                          : total_count + 1;
                        count_guest =
                          row.view === "guest" ? count_guest + 1 : count_guest;
                        count_logged =
                          row.view === "customer" ||
                          row.view === "client" ||
                          row.view === "agent"
                            ? count_logged + 1
                            : count_logged;
                        total_premium = row.cancel
                          ? total_premium - parseFloat(row.revised_net_premium)
                          : total_premium + parseFloat(row.revised_net_premium);
                        premium_logged =
                          row.view === "customer" ||
                          row.view === "client" ||
                          row.view === "agent"
                            ? !row.cancel
                              ? premium_logged +
                                parseFloat(row.revised_net_premium)
                              : premium_logged -
                                parseFloat(row.revised_net_premium)
                            : premium_logged;
                        premium_guest =
                          row.view === "guest"
                            ? !row.cancel
                              ? premium_guest +
                                parseFloat(row.revised_net_premium)
                              : premium_guest -
                                parseFloat(row.revised_net_premium)
                            : premium_guest;
                      });

                      return (
                        <React.Fragment key={idxInfo}>
                          <TableRow>
                            <TableCell
                              colSpan={25}
                              style={{
                                background: COLORS.main,
                                color: "#fff",
                                fontWeight: 700,
                              }}
                            >
                              Agency
                            </TableCell>
                          </TableRow>
                          <TableRow className="odd gradeX">
                            <TableCell colSpan={8}>
                              {info.agency?.code}
                            </TableCell>
                            <TableCell colSpan={16}>
                              {info.agency?.name}
                            </TableCell>
                          </TableRow>
                          <TableRow
                            style={{
                              background: COLORS.pastel1,
                              color: "#000",
                            }}
                          >
                            <TableCell colSpan={8}>Purchase Site</TableCell>
                            <TableCell colSpan={8}># policies</TableCell>
                            <TableCell colSpan={9}>Net Premium</TableCell>
                          </TableRow>
                          <TableRow className="odd gradeX">
                            <TableCell colSpan={8}>Guest</TableCell>
                            <TableCell colSpan={8}>{count_guest}</TableCell>
                            <TableCell colSpan={9}>
                              ${fmtMoney(premium_guest)}
                            </TableCell>
                          </TableRow>
                          <TableRow className="odd gradeX">
                            <TableCell colSpan={8}>Logged In</TableCell>
                            <TableCell colSpan={8}>{count_logged}</TableCell>
                            <TableCell colSpan={9}>
                              ${fmtMoney(premium_logged)}
                            </TableCell>
                          </TableRow>
                          <TableRow className="odd gradeX">
                            <TableCell colSpan={8}>Total</TableCell>
                            <TableCell colSpan={8}>{total_count}</TableCell>
                            <TableCell colSpan={9}>
                              ${fmtMoney(total_premium)}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                    {infos.length > 1 && (
                      <React.Fragment>
                        <TableRow>
                          <TableCell
                            colSpan={25}
                            style={{
                              background: COLORS.main,
                              color: "#fff",
                              fontWeight: 700,
                            }}
                          >
                            Total
                          </TableCell>
                        </TableRow>
                        <TableRow className="odd gradeX">
                          <TableCell colSpan={25}>All Agents</TableCell>
                        </TableRow>
                        <TableRow
                          style={{ background: COLORS.pastel1, color: "#000" }}
                        >
                          <TableCell colSpan={8}>Purchase Site</TableCell>
                          <TableCell colSpan={8}># policies</TableCell>
                          <TableCell colSpan={9}>Net Premium</TableCell>
                        </TableRow>
                        <TableRow className="odd gradeX">
                          <TableCell colSpan={8}>Guest</TableCell>
                          <TableCell colSpan={8}>{count_grand_guest}</TableCell>
                          <TableCell colSpan={9}>
                            ${fmtMoney(premium_grand_guest)}
                          </TableCell>
                        </TableRow>
                        <TableRow className="odd gradeX">
                          <TableCell colSpan={8}>Logged In</TableCell>
                          <TableCell colSpan={8}>
                            {count_grand_logged}
                          </TableCell>
                          <TableCell colSpan={9}>
                            ${fmtMoney(premium_grand_logged)}
                          </TableCell>
                        </TableRow>
                        <TableRow className="odd gradeX">
                          <TableCell colSpan={8}>Grand Total</TableCell>
                          <TableCell colSpan={8}>{total_grand_count}</TableCell>
                          <TableCell colSpan={9}>
                            ${fmtMoney(total_grand_premium)}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(18, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(18, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
